export default __webpack_public_path__ + "static/media/ico_plus.781ceb95.svg";